export const SUPPORTED_LANGUAGES = ['en', 'pt', 'es', 'fr'];

export const translations = {
  en: {
    app: {
      adLabel: 'Advertisement',
    },
    language: {
      en: 'English',
      pt: 'Portuguese',
      es: 'Spanish',
      fr: 'French',
      menuLabel: 'Change language',
    },
    common: {
      close: 'Close',
      clearFilter: 'Clear Filter',
      categories: 'Categories',
      products: 'Products',
      search: 'Search',
      previous: 'Previous',
      next: 'Next',
      pageOf: 'Page {{page}} of {{total}}',
      loadingProducts: 'Loading products...',
      productsCount: '{{count}} products',
      noProductsFound: 'No products found',
    },
    header: {
      login: 'Login',
      logout: 'Logout',
      hiUser: 'Hi, {{name}}',
      searchPlaceholder: 'Search products or EAN...',
      clearSearch: 'Clear search',
    },
    auth: {
      myAccount: 'My account',
      helloUser: 'Hello, {{name}}',
      createAccount: 'Create account',
      usernameOrEmail: 'Username or email',
      username: 'Username',
      email: 'Email',
      password: 'Password',
      signUp: 'Sign up',
      createAnAccount: 'Create an account',
      haveAccountLogin: 'Already have an account? Login',
      googleFailed: 'Google sign-in failed.',
      continueWithGoogle: 'Continue with Google',
      authFailed: 'Authentication failed.',
    },
    landing: {
      heroTitle: 'Compare prices and save!',
      heroSubtitle: 'Find the best grocery prices across Portuguese supermarkets',
      statUpdated: 'Updated prices',
      statProducts: 'Thousands of products',
      statSmart: 'Smart comparison',
      eyebrow: 'Grocery price comparison',
      prop1: "Don't get fooled",
      prop2: 'Make smarter decisions',
      prop3: 'Smarter shopping',
      allCategories: 'All categories',
      searchPlaceholder: 'Search product, brand or EAN...',
      searchButton: 'Search',
      searchViewAll: 'View all results',
      categoriesTitle: 'Categories',
      otherCategories: 'Others',
      viewAll: 'View all',
      recentlyViewed: 'Recently viewed',
      clearRecent: 'Clear',
      howItWorks: 'How It Works',
      step1Title: '1. Search',
      step1Text: 'Find the products you want to buy',
      step2Title: '2. Compare',
      step2Text: 'Check prices across different supermarkets',
      savingsExampleBadge: '+€1.20 saved',
      step3Title: '3. Save',
      step3Text: 'Pick the best option and save money',
      step4Title: "4. Don't get fooled",
      step4Text: 'Don\'t fall for pricing traps.',
      heroPrimaryCta: 'Start your smart list',
      heroSecondaryCta: 'How it works',
      categoriesSubtitle: 'Curated collections for your weekly essentials.',
      recentSubtitle: 'Jump back into products you viewed recently.',
      recentFallbackMeta: 'Product',
      recentPrimaryAction: 'View product',
      recentSecondaryAction: 'Compare now',
      description: 'Poupix automatically compares prices of thousands of products across Continente, Auchan, Intermarché and Pingo Doce. No registration, no app — search a product and instantly see where it\'s cheapest.',
    },
    productGrid: {
      categoryMenuAria: 'Category menu',
      mobileOpenFilters: 'Categories',
      paginationAria: 'Products pagination',
      filterByCategory: 'Filter by category',
      closeCategoryFilters: 'Close category filters',
      expandSubcategories: 'Expand subcategories',
      collapseSubcategories: 'Collapse subcategories',
      allCategories: 'All categories',
      failedLoad: 'Failed to load products. Please try again later.',
      sortBy: 'Sort by',
      sortRelevance: 'Most Relevant',
      sortPriceAsc: 'Price: Low to High',
      sortPriceDesc: 'Price: High to Low',
      sortSavings: 'Savings Amount',
    },
    productTile: {
      openProduct: 'Open {{name}}',
      priceUnavailable: 'Price unavailable',
      decreaseQuantity: 'Decrease quantity',
      increaseQuantity: 'Increase quantity',
      addToCart: 'Add to cart',
      addedToCart: 'Added to cart',
      pricePerKg: 'price/kg',
    },
    productDetail: {
      loading: 'Loading product...',
      breadcrumbs: 'Breadcrumb',
      home: 'Home',
      back: 'Go back',
      bestPrice: 'Best price',
      updated: 'Updated: {{date}}',
      quantity: 'Quantity',
      addToCart: 'Add to cart',
      favorite: 'Favorite',
      refreshingPrices: 'Updating prices...',
      stalePriceQuestion: 'Is this price outdated?',
      refreshOk: 'Updated {{refreshed}}/{{requested}} prices.',
      refreshErr: 'Failed to update prices.',
      priceComparison: 'Price Comparison',
      bestValue: 'Best value',
      cheapest: 'Cheapest',
      samePrice: 'Same price',
      moreExpensive: '{{pct}}% more expensive',
      alternatives: 'Other options for {{name}}',
      specifications: 'Product Specifications',
      unit: 'Unit',
      brand: 'Brand',
      previous: 'Previous',
      next: 'Next',
      current: 'Current',
      viewDetails: 'View Details',
      unknown: 'Unknown',
      soldByWeight: 'Sold by weight',
    },
    cart: {
      title: 'Shopping Cart',
      productsCount: '{{count}} products',
      clearCart: 'Clear Cart',
      closeEsc: 'Close (Esc)',
      empty: 'Your cart is empty',
      confirmClear: 'Are you sure you want to clear the cart?',
      noBrand: 'No brand',
      totalsComparison: 'Totals Comparison',
      smartOption: 'Smart Option',
      smartDesc: 'Buy each product where it is cheapest',
      productsN: '{{count}} products',
      saveUpTo: 'Save up to {{value}} with Smart Option',
      unknown: 'Unknown',
      allIn: 'All in {{name}}',
      singleCartTitle: 'Single-supermarket cart',
      singleCartDesc: 'No supermarket covers all items right now.',
      secondSingleTitle: 'Second cheapest single cart',
      secondSingleDesc: 'A second complete cart option is not available yet.',
      thirdSingleTitle: 'Third cheapest single cart',
      thirdSingleDesc: 'A third complete cart option is not available yet.',
      smartListTitle: 'Your smart cart',
      smartCartSubtitle: 'Automatically selecting the lowest price for every single item.',
      smartTotal: 'Smart Total',
      cheapestAt: 'Cheapest at {{name}}',
      removeItem: 'Remove item',
      totalSavings: 'Total Savings',
      saveAgainstSingleStore: 'Save {{value}} vs. single-store shopping',
      smartOptimizationApplied: 'Smart optimization is already applied to this basket.',
      marketRank: 'Market Rank',
      updatedLive: 'Updated live',
      singleStoreComparison: 'Single Store Comparison',
      bestSingleStore: 'Best Single Store',
      comparisonNote: 'Single-store totals show the cost of buying the entire basket at one supermarket only.',
    },
    bottomNav: {
      navAria: 'Main navigation',
      categoriesAria: 'Categories',
      scanAria: 'Scan barcode',
      cartLabel: 'Cart',
      cartAria: 'Cart - {{count}} {{itemLabel}}',
      itemSingular: 'product',
      itemPlural: 'products',
      notFoundTitle: 'Product not found',
      notFoundText: 'We could not find any product with EAN {{ean}}.',
      close: 'Close',
      searchAnyway: 'Search anyway',
      searchingTitle: 'Searching...',
      searchingText: 'Looking up EAN {{ean}}.',
    },
    scanner: {
      title: 'Scan barcode',
      close: 'Close',
      noCamera: 'Camera is not available on this device. Check permissions and use HTTPS.',
      cameraStartFail: 'Could not start the scanner. Check camera permissions or enter the EAN manually.',
      cameraInitFail: 'Could not initialize camera reader.',
      cameraHint: 'Point the camera at the barcode',
      manualLabel: 'Or enter EAN manually:',
      manualPlaceholder: 'e.g.: 5601006073568',
      manualSearch: 'Search',
      cameraPermDenied: 'Camera access was denied. Enter the EAN manually.',
      cameraPermHint: 'Allow camera in Settings → Safari / Chrome.',
    },
    installGate: {
      aria: 'Install application',
      close: 'Close',
      headerSub: 'No App Store needed',
      step1pre: 'Tap the ',
      step1share: 'Share',
      step1post: ' button below',
      step2pre: 'Tap ',
      step2action: 'Add to Home Screen',
      step3pre: 'Tap ',
      step3action: 'Add',
      step3post: ' to confirm',
      shareBelow: 'Share button is down here',
      alreadyInstalled: 'Already installed',
      androidText: 'Install Poupix for faster access, and exclusive mobile features, like barcode scanning.',
      install: 'Install app',
      continueBrowser: 'Use in browser',
    },
    googleCallback: {
      failedTitle: 'Google login failed',
      backHome: 'Back to home',
      signingIn: 'Signing you in...',
      wait: 'Please wait while we finish Google authentication.',
      oauthFailed: 'Google OAuth failed: {{error}}',
      missingToken: 'Google OAuth did not return an id_token.',
      nonceFail: 'Google OAuth nonce validation failed. Please try again.',
    },
    footer: {
      contact: 'Contact',
      privacy: 'Privacy Policy',
    },
    contact: {
      title: 'Contact',
      description: 'For all questions, feedback or support, please email us at:',
      aboutTitle: 'About Poupix',
      about: 'Poupix is a free supermarket price comparison tool for Portugal. No registration required — just search for a product and instantly see where it\'s cheapest.',
      supermarkets: 'We cover Continente, Auchan, Intermarché and Pingo Doce.',
      howPricesWork: 'Prices are updated regularly through automated scraping. They reflect the price at the time of the last update and may not be real-time.',
    },
  },
  pt: {
    app: {
      adLabel: 'Publicidade',
    },
    language: {
      en: 'Inglês',
      pt: 'Português',
      es: 'Espanhol',
      fr: 'Francês',
      menuLabel: 'Mudar idioma',
    },
    common: {
      close: 'Fechar',
      clearFilter: 'Limpar filtro',
      categories: 'Categorias',
      products: 'Produtos',
      search: 'Pesquisar',
      previous: 'Anterior',
      next: 'Seguinte',
      pageOf: 'Página {{page}} de {{total}}',
      loadingProducts: 'A carregar produtos...',
      productsCount: '{{count}} produtos',
      noProductsFound: 'Nenhum produto encontrado',
    },
    header: {
      login: 'Login',
      logout: 'Logout',
      hiUser: 'Olá, {{name}}',
      searchPlaceholder: 'Pesquisar produtos ou EAN...',
      clearSearch: 'Limpar pesquisa',
    },
    auth: {
      myAccount: 'A minha conta',
      helloUser: 'Olá, {{name}}',
      createAccount: 'Criar conta',
      usernameOrEmail: 'Utilizador ou email',
      username: 'Utilizador',
      email: 'Email',
      password: 'Palavra-passe',
      signUp: 'Registar',
      createAnAccount: 'Criar uma conta',
      haveAccountLogin: 'Já tens conta? Login',
      googleFailed: 'Falha no login com Google.',
      continueWithGoogle: 'Continuar com Google',
      authFailed: 'Falha de autenticação.',
    },
    landing: {
      heroTitle: 'Compare preços e poupe!',
      heroSubtitle: 'Encontre os melhores preços de produtos nos supermercados portugueses.',
      statUpdated: 'Preços atualizados',
      statProducts: 'Milhares de produtos',
      statSmart: 'Comparação inteligente',
      eyebrow: 'Comparador de preços',
      prop1: "Não se deixe enganar",
      prop2: 'Tome decisões mais inteligentes',
      prop3: 'Compras mais inteligentes',
      allCategories: 'Todas as categorias',
      searchPlaceholder: 'Procurar produto, marca ou EAN...',
      searchButton: 'Procurar',
      searchViewAll: 'Ver todos os resultados',
      categoriesTitle: 'Categorias',
      otherCategories: 'Outras',
      viewAll: 'Ver todos',
      recentlyViewed: 'Vistos recentemente',
      clearRecent: 'Limpar',
      howItWorks: 'Como Funciona',
      step1Title: '1. Procure',
      step1Text: 'Encontre os produtos que pretende comprar.',
      step2Title: '2. Compare',
      step2Text: 'Veja os preços em diferentes supermercados.',
      savingsExampleBadge: '+€1,20 poupado',
      step3Title: '3. Poupe',
      step3Text: 'Escolha a melhor opção e economize dinheiro.',
      step4Title: '4. Não se deixe enganar',
      step4Text: 'Não caia em armadilhas de preços.',
      heroPrimaryCta: 'Criar lista inteligente',
      heroSecondaryCta: 'Como funciona',
      categoriesSubtitle: 'Coleções selecionadas para as suas compras da semana.',
      recentSubtitle: 'Retome rapidamente os produtos que viu recentemente.',
      recentFallbackMeta: 'Produto',
      recentPrimaryAction: 'Ver produto',
      recentSecondaryAction: 'Comparar já',
      description: 'Poupix compara automaticamente os preços de milhares de produtos em Continente, Auchan, Intermarché e Pingo Doce. Sem registo, sem aplicação — pesquise um produto e veja imediatamente onde está mais barato.',
    },
    productGrid: {
      categoryMenuAria: 'Menu de categorias',
      mobileOpenFilters: 'Categorias',
      paginationAria: 'Paginação de produtos',
      filterByCategory: 'Filtrar por categoria',
      closeCategoryFilters: 'Fechar filtros de categoria',
      expandSubcategories: 'Expandir subcategorias',
      collapseSubcategories: 'Recolher subcategorias',
      allCategories: 'Todas as categorias',
      failedLoad: 'Falha ao carregar produtos. Tenta novamente mais tarde.',
      sortBy: 'Ordenar por',
      sortRelevance: 'Mais Relevante',
      sortPriceAsc: 'Preço: Menor para Maior',
      sortPriceDesc: 'Preço: Maior para Menor',
      sortSavings: 'Maior Poupança',
    },
    productTile: {
      openProduct: 'Abrir {{name}}',
      priceUnavailable: 'Preço indisponível',
      decreaseQuantity: 'Diminuir quantidade',
      increaseQuantity: 'Aumentar quantidade',
      addToCart: 'Adicionar ao carrinho',
      addedToCart: 'Adicionado ao carrinho',
      pricePerKg: 'preço/kg',
    },
    productDetail: {
      loading: 'A carregar produto...',
      breadcrumbs: 'Breadcrumb',
      home: 'Home',
      back: 'Voltar',
      bestPrice: 'Melhor preço',
      updated: 'Atualizado: {{date}}',
      quantity: 'Quantidade',
      addToCart: 'Adicionar ao carrinho',
      favorite: 'Favorito',
      refreshingPrices: 'A atualizar preços...',
      stalePriceQuestion: 'Este preço está desatualizado?',
      refreshOk: 'Atualizados {{refreshed}}/{{requested}} preços.',
      refreshErr: 'Falha ao atualizar preços.',
      priceComparison: 'Comparação de Preços',
      bestValue: 'Melhor valor',
      cheapest: 'Mais barato',
      samePrice: 'Preço igual',
      moreExpensive: '{{pct}}% mais caro',
      alternatives: 'Outras opções de {{name}}',
      specifications: 'Especificações do Produto',
      unit: 'Unidade',
      brand: 'Marca',
      previous: 'Anterior',
      next: 'Próximo',
      current: 'Atual',
      viewDetails: 'Ver Detalhes',
      unknown: 'Desconhecido',
      soldByWeight: 'Produto vendido ao peso',
    },
    cart: {
      title: 'Carrinho de Compras',
      productsCount: '{{count}} produtos',
      clearCart: 'Limpar Carrinho',
      closeEsc: 'Fechar (Esc)',
      empty: 'O seu carrinho está vazio',
      confirmClear: 'Tem certeza que deseja limpar o carrinho?',
      noBrand: 'Sem marca',
      totalsComparison: 'Comparação de Totais',
      smartOption: 'Opção Inteligente',
      smartDesc: 'Compre cada produto onde é mais barato',
      productsN: '{{count}} produtos',
      saveUpTo: 'Poupe até {{value}} com a Opção Inteligente',
      unknown: 'Desconhecido',
      allIn: 'Tudo em {{name}}',
      singleCartTitle: 'Carrinho de supermercado único',
      singleCartDesc: 'Nenhum supermercado cobre todos os itens neste momento.',
      secondSingleTitle: 'Segundo cesto único mais barato',
      secondSingleDesc: 'Uma segunda opção de carrinho completo ainda não está disponível.',
      thirdSingleTitle: 'Terceiro cesto único mais barato',
      thirdSingleDesc: 'Uma terceira opção de carrinho completo ainda não está disponível.',
      smartListTitle: 'O seu carrinho inteligente',
      smartCartSubtitle: 'Selecionamos automaticamente o menor preço para cada produto.',
      smartTotal: 'Total Inteligente',
      cheapestAt: 'Mais barato em {{name}}',
      removeItem: 'Remover item',
      totalSavings: 'Poupança Total',
      saveAgainstSingleStore: 'Poupe {{value}} face a comprar tudo numa só loja',
      smartOptimizationApplied: 'A otimização inteligente já está aplicada neste carrinho.',
      marketRank: 'Ranking dos Supermercados',
      updatedLive: 'Atualizado em direto',
      singleStoreComparison: 'Comparação por Supermercado',
      bestSingleStore: 'Melhor supermercado único',
      comparisonNote: 'Os totais por supermercado mostram o custo de comprar todo o carrinho numa única loja.',
    },
    bottomNav: {
      navAria: 'Navegação principal',
      categoriesAria: 'Categorias',
      scanAria: 'Ler código de barras',
      cartLabel: 'Carrinho',
      cartAria: 'Carrinho - {{count}} {{itemLabel}}',
      itemSingular: 'produto',
      itemPlural: 'produtos',
      notFoundTitle: 'Produto não encontrado',
      notFoundText: 'Não encontrámos nenhum produto com o EAN {{ean}}.',
      close: 'Fechar',
      searchAnyway: 'Pesquisar mesmo assim',
      searchingTitle: 'A procurar...',
      searchingText: 'A pesquisar EAN {{ean}}.',
    },
    scanner: {
      title: 'Ler código de barras',
      close: 'Fechar',
      noCamera: 'Câmara não disponível neste dispositivo. Verifica permissões e usa HTTPS.',
      cameraStartFail: 'Não foi possível iniciar o leitor. Verifica permissões da câmara ou introduz o EAN manualmente.',
      cameraInitFail: 'Não foi possível iniciar o leitor da câmara.',
      cameraHint: 'Aponta a câmara para o código de barras',
      manualLabel: 'Ou introduz o EAN manualmente:',
      manualPlaceholder: 'ex: 5601006073568',
      manualSearch: 'Pesquisar',
      cameraPermDenied: 'Acesso à câmara negado. Introduz o EAN manualmente.',
      cameraPermHint: 'Permite a câmara em Definições → Safari / Chrome.',
    },
    installGate: {
      aria: 'Instalar aplicação',
      close: 'Fechar',
      headerSub: 'Sem App Store',
      step1pre: 'Toca no botão ',
      step1share: 'Partilhar',
      step1post: ' abaixo',
      step2pre: 'Toca em ',
      step2action: 'Adicionar ao ecrã inicial',
      step3pre: 'Toca em ',
      step3action: 'Adicionar',
      step3post: ' para confirmar',
      shareBelow: 'O botão de partilha está aqui em baixo',
      alreadyInstalled: 'Já instalei',
      androidText: 'Instala o Poupix para acesso mais rápido, e funcionalidades exclusivas, como leitor de código de barras.',
      install: 'Instalar app',
      continueBrowser: 'Continuar no browser',
    },
    googleCallback: {
      failedTitle: 'Falha no login Google',
      backHome: 'Voltar ao início',
      signingIn: 'A iniciar sessão...',
      wait: 'Aguarda enquanto terminamos a autenticação Google.',
      oauthFailed: 'Google OAuth falhou: {{error}}',
      missingToken: 'Google OAuth não devolveu id_token.',
      nonceFail: 'Validação de nonce Google OAuth falhou. Tenta novamente.',
    },
    footer: {
      contact: 'Contacto',
      privacy: 'Política de Privacidade',
    },
    contact: {
      title: 'Contacto',
      description: 'Para todas as questões, feedback ou suporte, envie-nos um email para:',
      aboutTitle: 'Sobre o Poupix',
      about: 'O Poupix é um comparador de preços de supermercado gratuito para Portugal. Sem registo necessário — pesquise um produto e veja imediatamente onde está mais barato.',
      supermarkets: 'Comparamos preços no Continente, Auchan, Intermarché e Pingo Doce.',
      howPricesWork: 'Os preços são atualizados regularmente de forma automática. Refletem o preço no momento da última atualização e podem não ser em tempo real.',
    },
  },
  es: {
    app: {
      adLabel: 'Publicidad',
    },
    language: {
      en: 'Inglés',
      pt: 'Portugués',
      es: 'Español',
      fr: 'Francés',
      menuLabel: 'Cambiar idioma',
    },
    common: {
      close: 'Cerrar',
      clearFilter: 'Limpiar filtro',
      categories: 'Categorias',
      products: 'Productos',
      search: 'Buscar',
      previous: 'Anterior',
      next: 'Siguiente',
      pageOf: 'Pagina {{page}} de {{total}}',
      loadingProducts: 'Cargando productos...',
      productsCount: '{{count}} productos',
      noProductsFound: 'No se encontraron productos',
    },
    header: {
      login: 'Iniciar sesión',
      logout: 'Cerrar sesión',
      hiUser: 'Hola, {{name}}',
      searchPlaceholder: 'Buscar productos o EAN...',
      clearSearch: 'Limpiar búsqueda',
    },
    auth: {
      myAccount: 'Mi cuenta',
      helloUser: 'Hola, {{name}}',
      createAccount: 'Crear cuenta',
      usernameOrEmail: 'Usuario o email',
      username: 'Usuario',
      email: 'Email',
      password: 'Contraseña',
      signUp: 'Registrarse',
      createAnAccount: 'Crear una cuenta',
      haveAccountLogin: 'Ya tienes cuenta? Iniciar sesión',
      googleFailed: 'Fallo al iniciar sesión con Google.',
      continueWithGoogle: 'Continuar con Google',
      authFailed: 'Fallo de autenticación.',
    },
    landing: {
      heroTitle: 'Compara precios y ahorra!',
      heroSubtitle: 'Encuentra los mejores precios de supermercado en Portugal',
      statUpdated: 'Precios actualizados',
      statProducts: 'Miles de productos',
      statSmart: 'Comparacion inteligente',
      eyebrow: 'Comparador de precios',
      prop1: "Don't get fooled",
      prop2: 'Maker smarter decidions',
      prop3: 'Smarter shopping',
      allCategories: 'Todas las categorias',
      searchPlaceholder: 'Buscar producto, marca o EAN...',
      searchButton: 'Buscar',
      searchViewAll: 'Ver todos los resultados',
      categoriesTitle: 'Categorias',
      otherCategories: 'Otras',
      viewAll: 'Ver todo',
      recentlyViewed: 'Vistos recientemente',
      clearRecent: 'Borrar',
      howItWorks: 'Como funciona',
      step1Title: '1. Busca',
      step1Text: 'Encuentra los productos que quieres comprar',
      step2Title: '2. Compara',
      step2Text: 'Ve los precios en distintos supermercados',
      savingsExampleBadge: '+€1,20 ahorrado',
      step3Title: '3. Ahorra',
      step3Text: 'Elige la mejor opcion y ahorra dinero',
      step4Title: '4. No te dejes engañar',
      step4Text: 'No caigas en trampas de precios.',
      heroPrimaryCta: 'Crear lista inteligente',
      heroSecondaryCta: 'Como funciona',
      categoriesSubtitle: 'Colecciones pensadas para tus compras semanales.',
      recentSubtitle: 'Vuelve rapidamente a los productos que viste hace poco.',
      recentFallbackMeta: 'Producto',
      recentPrimaryAction: 'Ver producto',
      recentSecondaryAction: 'Comparar ahora',
      description: 'Poupix compara automáticamente los precios de miles de productos en Continente, Auchan, Intermarché y Pingo Doce. Sin registro, sin aplicación — busca un producto y ve al instante dónde es más barato.',
    },
    productGrid: {
      categoryMenuAria: 'Menu de categorias',
      mobileOpenFilters: 'Categorias',
      paginationAria: 'Paginacion de productos',
      filterByCategory: 'Filtrar por categoria',
      closeCategoryFilters: 'Cerrar filtros de categoria',
      expandSubcategories: 'Expandir subcategorias',
      collapseSubcategories: 'Colapsar subcategorias',
      allCategories: 'Todas las categorias',
      failedLoad: 'No se pudieron cargar los productos. Intenta mas tarde.',
      sortBy: 'Ordenar por',
      sortRelevance: 'Mas Relevante',
      sortPriceAsc: 'Precio: Menor a Mayor',
      sortPriceDesc: 'Precio: Mayor a Menor',
      sortSavings: 'Mayor Ahorro',
    },
    productTile: {
      openProduct: 'Abrir {{name}}',
      priceUnavailable: 'Precio no disponible',
      decreaseQuantity: 'Disminuir cantidad',
      increaseQuantity: 'Aumentar cantidad',
      addToCart: 'Agregar al carrito',
      addedToCart: 'Agregado al carrito',
      pricePerKg: 'precio/kg',
    },
    productDetail: {
      loading: 'Cargando producto...',
      breadcrumbs: 'Ruta',
      home: 'Inicio',
      back: 'Volver',
      bestPrice: 'Mejor precio',
      updated: 'Actualizado: {{date}}',
      quantity: 'Cantidad',
      addToCart: 'Agregar al carrito',
      favorite: 'Favorito',
      refreshingPrices: 'Actualizando precios...',
      stalePriceQuestion: 'Este precio esta desactualizado?',
      refreshOk: 'Actualizados {{refreshed}}/{{requested}} precios.',
      refreshErr: 'Error al actualizar precios.',
      priceComparison: 'Comparacion de precios',
      bestValue: 'Mejor valor',
      cheapest: 'Mas barato',
      samePrice: 'Mismo precio',
      moreExpensive: '{{pct}}% mas caro',
      alternatives: 'Otras opciones de {{name}}',
      previous: 'Anterior',
      next: 'Siguiente',
      current: 'Actual',
      viewDetails: 'Ver detalles',
      unknown: 'Desconocido',
      soldByWeight: 'Vendido por peso',
    },
    cart: {
      title: 'Carrito de compras',
      productsCount: '{{count}} productos',
      clearCart: 'Vaciar carrito',
      closeEsc: 'Cerrar (Esc)',
      empty: 'Tu carrito esta vacio',
      confirmClear: 'Seguro que quieres vaciar el carrito?',
      noBrand: 'Sin marca',
      totalsComparison: 'Comparacion de totales',
      smartOption: 'Opcion inteligente',
      smartDesc: 'Compra cada producto donde sea mas barato',
      productsN: '{{count}} productos',
      saveUpTo: 'Ahorra hasta {{value}} con la Opcion inteligente',
      unknown: 'Desconocido',
      allIn: 'Todo en {{name}}',
      singleCartTitle: 'Carrito de un solo supermercado',
      singleCartDesc: 'Ningun supermercado cubre todos los productos ahora mismo.',
      secondSingleTitle: 'Segundo carrito unico mas barato',
      secondSingleDesc: 'Aun no hay una segunda opcion completa disponible.',
      thirdSingleTitle: 'Tercer carrito unico mas barato',
      thirdSingleDesc: 'Aun no hay una tercera opcion completa disponible.',
      smartListTitle: 'Tu carrito inteligente',
      smartCartSubtitle: 'Seleccionamos automaticamente el precio mas bajo para cada producto.',
      smartTotal: 'Total Inteligente',
      cheapestAt: 'Mas barato en {{name}}',
      removeItem: 'Eliminar producto',
      totalSavings: 'Ahorro Total',
      saveAgainstSingleStore: 'Ahorra {{value}} frente a comprar todo en una sola tienda',
      smartOptimizationApplied: 'La optimizacion inteligente ya esta aplicada a este carrito.',
      marketRank: 'Ranking de Mercados',
      updatedLive: 'Actualizado en vivo',
      singleStoreComparison: 'Comparacion por tienda',
      bestSingleStore: 'Mejor tienda unica',
      comparisonNote: 'Los totales por tienda muestran el coste de comprar toda la cesta en un solo supermercado.',
    },
    bottomNav: {
      navAria: 'Navegacion principal',
      categoriesAria: 'Categorias',
      scanAria: 'Escanear codigo de barras',
      cartLabel: 'Carrito',
      cartAria: 'Carrito - {{count}} {{itemLabel}}',
      itemSingular: 'producto',
      itemPlural: 'productos',
      notFoundTitle: 'Producto no encontrado',
      notFoundText: 'No encontramos ningun producto con EAN {{ean}}.',
      close: 'Cerrar',
      searchAnyway: 'Buscar igualmente',
      searchingTitle: 'Buscando producto...',
      searchingText: 'Estamos buscando el EAN {{ean}} en la base de datos y supermercados.',
    },
    scanner: {
      title: 'Escanear codigo de barras',
      close: 'Cerrar',
      noCamera: 'Camara no disponible en este dispositivo. Verifica permisos y usa HTTPS.',
      cameraStartFail: 'No se pudo iniciar el lector. Verifica permisos de camara o introduce el EAN manualmente.',
      cameraInitFail: 'No se pudo iniciar el lector de camara.',
      cameraHint: 'Apunta la camara al codigo de barras',
      manualLabel: 'O introduce el EAN manualmente:',
      manualPlaceholder: 'ej: 5601006073568',
      manualSearch: 'Buscar',
      cameraPermDenied: 'Acceso a la cámara denegado. Introduce el EAN manualmente.',
      cameraPermHint: 'Permite la cámara en Ajustes → Safari / Chrome.',
    },
    installGate: {
      aria: 'Instalar aplicacion',
      close: 'Cerrar',
      headerSub: 'Sin App Store',
      step1pre: 'Toca el boton ',
      step1share: 'Compartir',
      step1post: ' de abajo',
      step2pre: 'Toca ',
      step2action: 'Agregar a pantalla de inicio',
      step3pre: 'Toca ',
      step3action: 'Agregar',
      step3post: ' para confirmar',
      shareBelow: 'El boton de compartir esta aqui abajo',
      alreadyInstalled: 'Ya la instale',
      androidText: 'Instala Poupix para acceso rapido, y lector de codigo de barras.',
      install: 'Instalar app',
      continueBrowser: 'Continuar en el navegador',
    },
    googleCallback: {
      failedTitle: 'Fallo de inicio con Google',
      backHome: 'Volver al inicio',
      signingIn: 'Iniciando sesion...',
      wait: 'Espera mientras terminamos la autenticacion con Google.',
      oauthFailed: 'Google OAuth fallo: {{error}}',
      missingToken: 'Google OAuth no devolvio id_token.',
      nonceFail: 'Fallo la validacion nonce de Google OAuth. Intentalo de nuevo.',
    },
    footer: {
      contact: 'Contacto',
      privacy: 'Política de Privacidad',
    },
    contact: {
      title: 'Contacto',
      description: 'Para todas las preguntas, comentarios o soporte, envíenos un correo electrónico a:',
      aboutTitle: 'Sobre Poupix',
      about: 'Poupix es un comparador de precios de supermercado gratuito para Portugal. Sin registro — busca un producto y ve al instante dónde es más barato.',
      supermarkets: 'Comparamos precios en Continente, Auchan, Intermarché y Pingo Doce.',
      howPricesWork: 'Los precios se actualizan regularmente de forma automática. Reflejan el precio en el momento de la última actualización y pueden no ser en tiempo real.',
    },
  },
  fr: {
    app: {
      adLabel: 'Publicite',
    },
    language: {
      en: 'Anglais',
      pt: 'Portugais',
      es: 'Espagnol',
      fr: 'Francais',
      menuLabel: 'Changer la langue',
    },
    common: {
      close: 'Fermer',
      clearFilter: 'Effacer le filtre',
      categories: 'Categories',
      products: 'Produits',
      search: 'Rechercher',
      previous: 'Precedent',
      next: 'Suivant',
      pageOf: 'Page {{page}} sur {{total}}',
      loadingProducts: 'Chargement des produits...',
      productsCount: '{{count}} produits',
      noProductsFound: 'Aucun produit trouve',
    },
    header: {
      login: 'Connexion',
      logout: 'Deconnexion',
      hiUser: 'Bonjour, {{name}}',
      searchPlaceholder: 'Rechercher des produits ou EAN...',
      clearSearch: 'Effacer la recherche',
    },
    auth: {
      myAccount: 'Mon compte',
      helloUser: 'Bonjour, {{name}}',
      createAccount: 'Creer un compte',
      usernameOrEmail: 'Nom d utilisateur ou email',
      username: 'Nom d utilisateur',
      email: 'Email',
      password: 'Mot de passe',
      signUp: 'S inscrire',
      createAnAccount: 'Creer un compte',
      haveAccountLogin: 'Vous avez deja un compte ? Connexion',
      googleFailed: 'Echec de connexion Google.',
      continueWithGoogle: 'Continuer avec Google',
      authFailed: 'Echec de l authentification.',
    },
    landing: {
      heroTitle: 'Comparez les prix et economisez !',
      heroSubtitle: 'Trouvez les meilleurs prix en supermarches portugais',
      statUpdated: 'Prix mis a jour',
      statProducts: 'Des milliers de produits',
      statSmart: 'Comparaison intelligente',
      eyebrow: 'Comparateur de prix',
      prop1: "Don't get fooled",
      prop2: 'Maker smarter decidions',
      prop3: 'Smarter shopping',
      allCategories: 'Toutes les categories',
      searchPlaceholder: 'Rechercher produit, marque ou EAN...',
      searchButton: 'Rechercher',
      searchViewAll: 'Voir tous les résultats',
      categoriesTitle: 'Categories',
      otherCategories: 'Autres',
      viewAll: 'Voir tout',
      recentlyViewed: 'Vus recemment',
      clearRecent: 'Effacer',
      howItWorks: 'Comment ca marche',
      step1Title: '1. Recherchez',
      step1Text: 'Trouvez les produits que vous voulez acheter',
      step2Title: '2. Comparez',
      step2Text: 'Consultez les prix dans differents supermarches',
      savingsExampleBadge: '+€1,20 economises',
      step3Title: '3. Economisez',
      step3Text: 'Choisissez la meilleure option et economisez',
      step4Title: '4. Ne vous faites pas avoir',
      step4Text: 'Ne vous laissez pas piéger par les prix.',
      heroPrimaryCta: 'Creer une liste intelligente',
      heroSecondaryCta: 'Comment ca marche',
      categoriesSubtitle: 'Des collections pensees pour vos courses de la semaine.',
      recentSubtitle: 'Retrouvez rapidement les produits consultes recemment.',
      recentFallbackMeta: 'Produit',
      recentPrimaryAction: 'Voir le produit',
      recentSecondaryAction: 'Comparer',
      description: 'Poupix compare automatiquement les prix de milliers de produits chez Continente, Auchan, Intermarché et Pingo Doce. Sans inscription, sans application — cherchez un produit et voyez immédiatement où il est le moins cher.',
    },
    productGrid: {
      categoryMenuAria: 'Menu des categories',
      mobileOpenFilters: 'Categories',
      paginationAria: 'Pagination des produits',
      filterByCategory: 'Filtrer par categorie',
      closeCategoryFilters: 'Fermer les filtres de categorie',
      expandSubcategories: 'Developper les sous-categories',
      collapseSubcategories: 'Replier les sous-categories',
      allCategories: 'Toutes les categories',
      failedLoad: 'Impossible de charger les produits. Reessayez plus tard.',
      sortBy: 'Trier par',
      sortRelevance: 'Plus Pertinent',
      sortPriceAsc: 'Prix : Croissant',
      sortPriceDesc: 'Prix : Decroissant',
      sortSavings: 'Meilleures Economies',
    },
    productTile: {
      openProduct: 'Ouvrir {{name}}',
      priceUnavailable: 'Prix indisponible',
      decreaseQuantity: 'Diminuer la quantite',
      increaseQuantity: 'Augmenter la quantite',
      addToCart: 'Ajouter au panier',
      addedToCart: 'Ajoute au panier',
      pricePerKg: 'prix/kg',
    },
    productDetail: {
      loading: 'Chargement du produit...',
      breadcrumbs: 'Fil d Ariane',
      home: 'Accueil',
      back: 'Retour',
      bestPrice: 'Meilleur prix',
      updated: 'Mis a jour : {{date}}',
      quantity: 'Quantite',
      addToCart: 'Ajouter au panier',
      favorite: 'Favori',
      refreshingPrices: 'Mise a jour des prix...',
      stalePriceQuestion: 'Ce prix est-il obsolete ?',
      refreshOk: '{{refreshed}}/{{requested}} prix mis a jour.',
      refreshErr: 'Echec de mise a jour des prix.',
      priceComparison: 'Comparaison des prix',
      bestValue: 'Meilleure valeur',
      cheapest: 'Le moins cher',
      samePrice: 'Meme prix',
      moreExpensive: '{{pct}}% plus cher',
      alternatives: 'Autres options pour {{name}}',
      previous: 'Precedent',
      next: 'Suivant',
      current: 'Actuel',
      viewDetails: 'Voir details',
      unknown: 'Inconnu',
      soldByWeight: 'Vendu au poids',
    },
    cart: {
      title: 'Panier',
      productsCount: '{{count}} produits',
      clearCart: 'Vider le panier',
      closeEsc: 'Fermer (Esc)',
      empty: 'Votre panier est vide',
      confirmClear: 'Voulez-vous vraiment vider le panier ?',
      noBrand: 'Sans marque',
      totalsComparison: 'Comparaison des totaux',
      smartOption: 'Option intelligente',
      smartDesc: 'Achetez chaque produit la ou il est le moins cher',
      productsN: '{{count}} produits',
      saveUpTo: 'Economisez jusqu a {{value}} avec l Option intelligente',
      unknown: 'Inconnu',
      allIn: 'Tout chez {{name}}',
      singleCartTitle: 'Panier supermarche unique',
      singleCartDesc: 'Aucun supermarche ne couvre tous les articles actuellement.',
      secondSingleTitle: 'Deuxieme panier unique le moins cher',
      secondSingleDesc: 'Une deuxieme option complete n est pas encore disponible.',
      thirdSingleTitle: 'Troisieme panier unique le moins cher',
      thirdSingleDesc: 'Une troisieme option complete n est pas encore disponible.',
      smartListTitle: 'Votre panier intelligent',
      smartCartSubtitle: 'Nous selectionnons automatiquement le prix le plus bas pour chaque article.',
      smartTotal: 'Total Intelligent',
      cheapestAt: 'Moins cher chez {{name}}',
      removeItem: 'Supprimer l article',
      totalSavings: 'Economies Totales',
      saveAgainstSingleStore: 'Economisez {{value}} par rapport a un achat dans une seule enseigne',
      smartOptimizationApplied: 'L optimisation intelligente est deja appliquee a ce panier.',
      marketRank: 'Classement des Enseignes',
      updatedLive: 'Mise a jour en direct',
      singleStoreComparison: 'Comparaison par enseigne',
      bestSingleStore: 'Meilleure enseigne unique',
      comparisonNote: 'Les totaux par enseigne montrent le cout d un achat complet dans un seul supermarche.',
    },
    bottomNav: {
      navAria: 'Navigation principale',
      categoriesAria: 'Categories',
      scanAria: 'Scanner code-barres',
      cartLabel: 'Panier',
      cartAria: 'Panier - {{count}} {{itemLabel}}',
      itemSingular: 'produit',
      itemPlural: 'produits',
      notFoundTitle: 'Produit introuvable',
      notFoundText: 'Aucun produit trouve avec EAN {{ean}}.',
      close: 'Fermer',
      searchAnyway: 'Rechercher quand meme',
      searchingTitle: 'Recherche du produit...',
      searchingText: 'Nous recherchons l EAN {{ean}} dans la base et les supermarches.',
    },
    scanner: {
      title: 'Scanner code-barres',
      close: 'Fermer',
      noCamera: 'Camera indisponible sur cet appareil. Verifiez les permissions et utilisez HTTPS.',
      cameraStartFail: 'Impossible de demarrer le lecteur. Verifiez les permissions camera ou saisissez l EAN manuellement.',
      cameraInitFail: 'Impossible de demarrer le lecteur camera.',
      cameraHint: 'Pointez la camera vers le code-barres',
      manualLabel: 'Ou saisissez l EAN manuellement :',
      manualPlaceholder: 'ex : 5601006073568',
      manualSearch: 'Rechercher',
      cameraPermDenied: 'Accès caméra refusé. Saisissez l EAN manuellement.',
      cameraPermHint: 'Autorisez la caméra dans Réglages → Safari / Chrome.',
    },
    installGate: {
      aria: 'Installer l application',
      close: 'Fermer',
      headerSub: 'Sans App Store',
      step1pre: 'Appuyez sur le bouton ',
      step1share: 'Partager',
      step1post: ' ci-dessous',
      step2pre: 'Appuyez sur ',
      step2action: 'Sur l ecran d accueil',
      step3pre: 'Appuyez sur ',
      step3action: 'Ajouter',
      step3post: ' pour confirmer',
      shareBelow: 'Le bouton partager est ici en bas',
      alreadyInstalled: 'Deja installee',
      androidText: 'Installez Poupix pour un acces rapide, comme le scanner de codes-barres.',
      install: 'Installer l app',
      continueBrowser: 'Continuer dans le navigateur',
    },
    googleCallback: {
      failedTitle: 'Echec de connexion Google',
      backHome: 'Retour a l accueil',
      signingIn: 'Connexion en cours...',
      wait: 'Veuillez patienter pendant la fin de l authentification Google.',
      oauthFailed: 'Google OAuth a echoue : {{error}}',
      missingToken: 'Google OAuth n a pas renvoye id_token.',
      nonceFail: 'La validation nonce Google OAuth a echoue. Reessayez.',
    },
    footer: {
      contact: 'Contact',
      privacy: 'Politique de Confidentialité',
    },
    contact: {
      title: 'Contact',
      description: 'Pour toutes questions, commentaires ou assistance, veuillez nous envoyer un e-mail à :',
      aboutTitle: 'À propos de Poupix',
      about: 'Poupix est un comparateur de prix de supermarché gratuit pour le Portugal. Sans inscription — cherchez un produit et voyez immédiatement où il est le moins cher.',
      supermarkets: 'Nous comparons les prix chez Continente, Auchan, Intermarché et Pingo Doce.',
      howPricesWork: 'Les prix sont mis à jour régulièrement de façon automatique. Ils reflètent le prix au moment de la dernière mise à jour et peuvent ne pas être en temps réel.',
    },
  },
};
